type Props = {
  type: 'success' | 'error';
  message: string;
};

export default function FormAlert({ type, message }: Props) {
  const isSuccess = type === 'success';
  return (
    <div
      role="alert"
      className={`px-4 py-3 border-l-2 ${isSuccess ? 'border-green-500 bg-green-50' : 'border-primary bg-primary/5'}`}
    >
      <p
        className={`font-sans text-[0.82rem] leading-relaxed ${isSuccess ? 'text-green-800' : 'text-primary'}`}
      >
        {message}
      </p>
    </div>
  );
}
